/**
 * The kiosk PIN (brief sections 6.4, 7.5 and 9): set by an admin in
 * Settings, asked to leave Hand the tablet and the booth kiosk. A device
 * checks it without the network, so the server gives signed-in devices its
 * salted PBKDF2 hash (never the PIN); each device counts its failed
 * attempts and locks itself for a while after too many (kioskPin of
 * config/portal.json).
 */
export const KIOSK_PIN_HASH = {
  name: 'PBKDF2',
  hash: 'SHA-256',
  iterations: 600_000,
  bits: 256,
} as const;

/** What a device receives and keeps to check the PIN offline. */
export interface KioskPinCheck {
  /** Base64. */
  salt: string;
  /** Base64. */
  hash: string;
  iterations: number;
  digits: number;
  setAt: string;
}

export function isKioskPinFormat(pin: string, digits: number): boolean {
  return new RegExp(`^\\d{${digits}}$`).test(pin);
}
